const vueProduct = new Vue({
    name: 'vueBasicProduct',
    el: '#vueProduct',
    data: {
        body: document.querySelector('body'),
        product: {
            properties: vueProduct_DATA.properties,
        },
        checkedNames: [],
        colours: vueProduct_DATA.colours,
        colourMatrixItems: vueProduct_DATA.colourMatrixItems,
        variantData: vueProduct_DATA.variantData,
        lastChangedProperty: null,
    },
    mounted() {
        const vm = this;
        vm.addRequiredAttributes();
        vm.setDefaultValues(vm.product.properties);
        vm.addColours(vm.colourMatrixItems);
        if (typeof precision !== 'undefined') {
            vm.addToCartButtonDisabled = true;
        }
    },
    mixins: [
        addToCartBarMixin,
        calcEngineServiceMixin,
        coloursMixin,
        discountTiersMixin,
        generalMixin,
        holesMixin,
        onLoadPropertiesMixin,
        productMixin,
        productPriceMixin,
        quantityMixin,
        requestServiceMixin,
        shoppingCartServiceMixin,
        validationMixin,
        vatMixin,
        quantityMixin,
        vatMixin,
        generalMixin,
        validationMixin,
        onLoadPropertiesMixin,
    ],
    methods: {
        addQuantity: function () {
            if (!this.validate()) return;

            quantityMixin.methods.addQuantity();
        },
        subtractQuantity: function () {
            if (!this.validate()) return;

            quantityMixin.methods.subtractQuantity();
        },
        selectColour: function (colour) {
            const colourVariantValue = this.getValueByOptionText("Colour", colour.name)

            this.product.properties.Colour = colourVariantValue;

            this.selected.product.colour = {
                name: colour.name,
                hexadecimalCode: colour.hexadecimalCode,
            };

            this.product.colour = colour.name;

            const thumbNailImg = document.querySelector(
                '.slider-nav-thumbnails img[data-media-id="' + colour.mediaId + '"]'
            );

            if (thumbNailImg) {
                changeSlideImgClick(thumbNailImg.parentElement.dataset.gslide);
            }

            this.$nextTick(() => {
                this.$refs.Colour.value = colourVariantValue;
                this.$refs.Colour.dispatchEvent(new Event('change'));
            });

            if (document.querySelector('.colour.is-invalid')) {
                document.querySelector('.colour.is-invalid').classList.remove('is-invalid');
            }

            this.$refs['selectColor'].classList.remove('is-invalid');
            this.$refs['selectColor'].parentElement.classList.remove('is-invalid');

            this.closeColoursModal();
        },
        getValueByOptionText: function (selectId, optionText) {
            // Get the select element by its ID
            const selectElement = document.getElementById(selectId);

            // Check if select element exists
            if (!selectElement) {
                return null;
            }

            // Convert options NodeList to an array to use array methods
            const options = Array.from(selectElement.options);

            // Find the option with the specified text and return its value
            const option = options.find(opt => opt.textContent.trim() === optionText);

            // Return the value if the option is found, otherwise return null
            return option ? option.value : null;
        },
        updateProductPrice: function (event) {
            var allowedProperties = this.allowedProperties(this.product.properties, this.variantData);
            let dataType = event.target.getAttribute('data-type');
            this.lastChangedProperty = dataType;

            this.updateDropdowns(allowedProperties);

            this.validate();

            if (!document.querySelector('.is-invalid')) {
                this.addToCartButtonDisabled = false;
               
                if (this.checkCombinationExists()) {
                    this.inStock = true
                    this.getProductPrice();
                    this.showFromPrice = false;
                } else {
                    this.inStock = false;
                    this.showFromPrice = true;
                }
            }
        },
        /**
        * Update dropdown elements based on the existingProperties object
        * @param {object} existingProperties - An object containing properties and corresponding values
        */
        updateDropdowns: function (existingProperties) {
            // Loop through all keys in the existingProperties object
            for (const [key, values] of Object.entries(existingProperties)) {
                // Find the select element that corresponds to the current key
                const selectElement = document.getElementById(key);
                if (selectElement) {
                    // Loop through all option elements of the select element
                    const options = selectElement.options;
                    for (let option of options) {
                        if (option.value == '0') {
                            // Skip the option if its value is '0'
                            continue;
                        }
                        if (key == this.lastChangedProperty) {
                            // If the key matches lastChangedProperty, remove the data-disabled attribute
                            option.removeAttribute('data-disabled');
                        } else {
                            // If the option's value is not in the existing values array, set the data-disabled attribute
                            if (!values.has(option.value)) {
                                option.setAttribute('data-disabled', 'true');
                            } else {
                                option.removeAttribute('data-disabled');
                            }
                        }
                    }
                }
            }

            // Call the function to disable options in the Colour modal
            //this.disableColourModalOptions();
        },
        disableColourModalOptions() {
            // First, clear all previous 'not-available' classes from modal elements
            document.querySelectorAll('[data-modal-colour].not-available').forEach(element => {
                element.classList.remove('not-available');

                // Append " - unavailable" to the label text
                const label = element.querySelector('label');
                if (label && label.textContent.includes(' - unavailable')) {
                    label.textContent = label.textContent.replace(' - unavailable', '');
                }
            });

            // Find all disabled options in the Colour select dropdown
            const disabledDropdownOptions = document.querySelectorAll('#Colour option[data-disabled="true"]');

            // Iterate over each disabled dropdown option
            disabledDropdownOptions.forEach(option => {
                // Extract the actual colour name (before the '|')
                const colourName = option.value.split('|')[0];

                // Find all modal elements with the data-modal-colour attribute that match the colour name
                const colourElements = document.querySelectorAll(`[data-modal-colour="${colourName}"]`);

                // Add the 'not-available' class to each matching modal element
                colourElements.forEach(element => {
                    element.classList.add('not-available');

                    // Append " - unavailable" to the label text
                    const label = element.querySelector('label');
                    if (label && !label.textContent.includes(' - unavailable')) {
                        label.textContent += ' - unavailable';
                    }
                });
            });
        },
        checkCombinationExists() {
            // Convert product properties to an array of objects for easier comparison
            const selectedOptions = Object.keys(this.product.properties).map(key => {
                return { name: key, value: this.product.properties[key] };
            });

            // Iterate through the variantData to check if the combination exists
            return vueProduct_DATA.variantData.some(combination => {
                return combination.every(option => {
                    const selectedOption = selectedOptions.find(so => so.name === option.name);
                    return selectedOption && selectedOption.value === option.value;
                });
            });
        },
        allowedProperties: function (productProperties, variantData) {
            let existingProperties = {};
            variantData.forEach(variant => {
                let isValidVariant = true;
                Object.entries(productProperties).forEach(([key, value]) => {
                    if (value !== 0 && value !== "0" && value !== "") {
                        let variantProperty = variant.find(option => option.name === key);
                        if (!variantProperty || variantProperty.value !== value) {
                            isValidVariant = false;
                        }
                    }
                });

                if (isValidVariant) {
                    variant.forEach(option => {
                        if (!existingProperties[option.name]) {
                            existingProperties[option.name] = new Set();
                        }
                        existingProperties[option.name].add(option.value);
                    });
                }
            });

            return existingProperties;
        },
        getProductPrice: function () {
            const vm = this;
            vm.isUpdating = true;

            const data = {
                productId: GLOBAL.PRODUCT.ID,
                properties: vm.mappedData(),
                quantity: this.product.quantity
            };

            vm.getBasicProductPriceApi(data).then(function (response) {
                if (!response)
                    return;

                const content = response.data.content;

                if (content.productPrice == null)
                    return;

                vm.priceResponse = content.productPrice;

                if (vm.priceResponse.productId !== 0) {
                    vm.product.id = vm.priceResponse.productId;
                } else {
                    vm.product.id = GLOBAL.PRODUCT.ID;
                }

                vm.calculateDiscountBarStyle();

                vm.showFromPrice = false;

                vm.hasCampaign = false;
            }).finally(function () {
                vm.isUpdating = false;
            });
        },
        validate: function () {
            const vm = this;
            vm.clearErrors();
            if (!vm.requiredFieldsAreValid()) {
                return false;
            }
            return true;
        },
        addToBasket: function () {
            const vm = this;

            if (vm.isAddingToCart) {
                return;
            }

            if (!vm.validate()) return;

            vm.isAddingToCart = true;

            const data = {
                productId: vm.product.id,
                quantity: vm.product.quantity,
                properties: vm.mappedData(),
            };

            vm.addBasicProductApi(data)
                .then(function (response) {
                    if (!response) {
                        vm.isAddingToCart = false;
                        vueAddToCartModal.openError();
                        return;
                    }

                    const content = response.data.content;

                    vueAddToCartModal.priceResponse = vueProduct.priceResponse
                    vueAddToCartModal.quantity = vueProduct.product.quantity;
                    vueAddToCartModal.addedProduct = content.addedProduct
                    vueShoppingCartCount.total = content.basketItemsTotal;

                    vueAddToCartModal.open();
                })
                .catch(function () {
                    vueAddToCartModal.openError();
                })
                .finally(() => {
                    vm.isAddingToCart = false;
                });
        },
        /**
         * Change data into a format suitable to sending, specifically for checkboxes
         */
        mappedData: function () {
            const vm = this;
            const properties = vm.product.properties;

            var dict = []; // create an empty array

            for (const property in properties) {
                var value = properties[property];

                if (!vm.isEmpty(value)) {
                    if (Array.isArray(properties[property])) {
                        value = value.sort().join('|');
                    }

                    dict.push({
                        key: property,
                        value: value,
                    });
                }
            }

            return dict;
        },
    }
});
